import React from "react";
import orderBy from "lodash/orderBy";
import Box from "@mui/material/Box";

export default function OutboundSummaryComponent({ entity }) {
  if (!entity.inventoryItems) return "";

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      width="100%"
      maxHeight="100%"
      overflow="auto"
      sx={{ overflowX: "hidden" }}
    >
      {orderBy(
        entity.inventoryItems.filter(item => item.inventoryRequest),
        v => v.inventoryRequest.workOrderNumber,
        "asc"
      ).map(
        (item, index) => (
          <Box key={index} component="div" sx={{ whiteSpace: "nowrap" }}>
            {item.inventoryRequest.workOrderNumber} ({item.quantity})
          </Box>
        )
      )}
    </Box>
  );
}
